import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

function Header({ scrollToIntro }) { // props 구조 수정
  const [top, setTop] = useState(false);

  const menuItem = [
    { id: 'Intro', label: 'menu1' },
    { id: 'Profile', label: 'menu2' },
    { id: 'Project', label: 'menu3' },
    { id: 'Contact', label: 'menu4' },
  ];

  // 메뉴 클릭 시 해당 section으로 이동
  const handleMenuClick = (id) => {
    if (id === "Intro" && scrollToIntro) {
      scrollToIntro();
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const handletopBtn = () => {
      setTop(window.scrollY > 200);
    };
    window.addEventListener('scroll', handletopBtn);
    return () => window.removeEventListener('scroll', handletopBtn);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header>
      <h1>
        <Link to='/portfolio'>
          Choi<br />
          Hwa<br />
          Bin<br />
        </Link>
      </h1>
      <nav>
        <ul>
          {menuItem.map(item => (
            <li key={item.id}>
              <button onClick={() => handleMenuClick(item.id)} aria-label='메뉴로 이동하기'>
                {item.id}
              </button>
            </li>
          ))}
        </ul>
      </nav>
      {top && (
        <div className='top_btn'>
          <button aria-label='탑버튼' onClick={scrollTop}>Up</button>
        </div>
      )}
    </header>
  );
}

export default Header;